import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDestroyTraining } from 'modules/trainings/hooks/Trainings/useDestroyTraining'

interface BulkDeleteProps {
  itemIds: number[]
  onClose: () => void
}

const BulkDelete = ({ itemIds, onClose }: BulkDeleteProps) => {
  const { destroyTraining, loading } = useDestroyTraining()

  const onSubmit = async () => {
    const response = await destroyTraining({ ids: itemIds })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.delete_training.error_delete_bulk'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.delete_training.success_delete_bulk'),
      })
      onClose()
    }
  }

  return (
    <OneModal isOpen onClose={onClose}>
      <OneModal.Header title={i18n.t('trainings.delete_training.title_bulk')} />
      <OneModal.Content withPadding>
        <Box gap="s8" flexDirection="column">
          <Text.Normal size="300">
            {i18n.t('trainings.delete_training.description_bulk')}
          </Text.Normal>
        </Box>
      </OneModal.Content>
      <OneModal.Footer>
        <Box flexDirection="row" gap="s12" justifyContent="flexEnd" width="full">
          <F0Button
            variant="outline"
            onClick={onClose}
            label={i18n.t('trainings.delete_training.cancel')}
          />
          <F0Button
            variant="critical"
            onClick={onSubmit}
            label={i18n.t('trainings.delete_training.accept')}
            type="submit"
            loading={loading}
          />
        </Box>
      </OneModal.Footer>
    </OneModal>
  )
}

export default BulkDelete
